import React, { useState } from "react";
import Loader from "../../../components/loader";
import { useBalancerPoolsData } from "../../../context/balancerPoolData";
import { PoolType } from "../../poolDetail/balancer/types";
import Web3 from "web3";

import {
  SecondaryIssueManager,
  contractAddress,
} from "@verified-network/verified-sdk";
import { useGlobal } from "../../../context/globalContext";
import UiTable from "../../../components/table/Table";
import { useNetworkOptions } from "../../../context/contractDataLoaderService";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { providers } from "ethers";

function ServicerHome(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const { data, loading } = useBalancerPoolsData(PoolType.SecondaryIssue);
  const filteredData = data.filter(
    (pool) =>
      pool.verifiedWalletData?.issuer?.id.toLowerCase() ===
        account.toLowerCase() &&
      !pool.verifiedWalletData?.subscriptionsClosed?.length
  );
  const { data: networkOptions } = useNetworkOptions();

  let secondaryIssueManagerContract;

  if (provider && provider.getSigner && chainId && address) {
    if (contractAddress[chainId].BalancerSecondaryIssueManager) {
      secondaryIssueManagerContract = new SecondaryIssueManager(
        signer,
        contractAddress[chainId].BalancerSecondaryIssueManager
      );
    }
  }

  let headers = [
    { label: "Start Date(UTC)", val: "createTime" },
    { label: "Security", val: "securitySymbolAsLink" },
    { label: "Currency", val: "currencySymbolAsLink" },
    { label: "Minimum Order Size", val: "minOrderSize" },
    { label: "Issue Fee", val: "issuingFee" },
    { label: "Call Action", val: "transactionCallAction" },
  ];

  const options = {
    onClick: (event, row) => {
      onInvest(row);
    },
  };

  const onInvest = (row) => {
    props.history.push(
      `/transactions/secondary_investors/${row.poolType}/${row.security}`
    );
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-100">
            <h3 className="text-left">Transactions</h3>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={data || []}
            hover
            bordered={false}
            userRole={userRole}
            rowEvents={options}
            web3={web3}
            account={account}
            chainId={chainId}
            networkOptions={networkOptions}
            contract={secondaryIssueManagerContract}
            signer={signer}
            verifiedWalletDetails={verifiedWalletDetails}
          />
        </div>
      </section>
    </>
  );
}

export default function SecondaryTransactions(props) {
  return <ServicerHome {...props} />;
}
